import React, { useEffect, useState } from "react";

import { Redirect, useParams } from "react-router-dom";
import { Box, Button, CircularProgress, CssBaseline, Link, TextField, Typography } from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import NDReferralHeader from "../../components/shared/ndreferralheader";
import { getApiUrl } from "../../services/api_service";
import { ValidateReferralOTP } from "./referrerlogin";
import { blackcolor, bodyBg, footerContainer, fullHeight, pcolor, rcolor, whitecolor } from "../../style2";
import Footer from "../../components/shared/footer";

export default function ReferrerRegister() {
    const { orgCode } = useParams();
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [organizationName, setOrganizationName] = useState('');
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [redirect, setRedirect] = useState('');
    const [showValidateOTP, setShowValidateOTP] = useState(false);
    const [isLoggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                setLoggedIn(true);
                setRedirect(`/referral/screenprocess/${orgCode}`);
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        });
    }, [])

    const registerFunc = () => {
        setError('');
        setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/ReferrerAccount/register`, {
            method: 'POST',
            body: JSON.stringify({
                name, email, title, organization: organizationName
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status === 200) {
                setSuccess('You are successfully registered, a passcode has been sent to your email address.');
                setTimeout(function () { setShowValidateOTP(true); }, 1500);

            }
            else if (response.status === 404) {
                setError("Please register to refer a child.")
            }
            else {
                response.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err => {
                    console.log(err);
                    setError("Unable to process request.");
                })
            }
        }).catch(err => {
            console.log(err);
            setError("Unable to contact server.");
        }).finally(() => {
            setLoading(false);
        })
    }

    if (redirect !== "")
        return <Redirect to={redirect} />
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
            <NDReferralHeader date={Date.UTC()} isLoggedIn={isLoggedIn} orgCode={orgCode} logo="../../Logo_Option_1.svg" />

            {showValidateOTP ?
                <Box sx={{ maxWidth: "800px", padding: "5rem 10rem", margin: "0 auto" }}>
                    <ValidateReferralOTP email={email} redirect={`/referral/screenprocess/${orgCode}`} /> </Box> :
                <Box sx={{ width: "50%", padding: "5rem 10rem", margin: "0 auto" }}>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        registerFunc();
                    }}>
                        <Box mb={1}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>
                                School / SENCO’S Email *</label>
                            <TextField inputProps={{ maxLength: "150", type: "email" }} style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "100%" }} variant="outlined" required={true} label="" value={email} onChange={(e) => {
                                setEmail(e.target.value);
                            }} />
                        </Box>
                        <Box mb={1}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Name *</label>
                            <TextField inputProps={{ maxLength: "50" }} style={{
                                border: `1px solid ${pcolor}`, borderRadius: 5,
                                width: "100%"
                            }} variant="outlined" required={true} label="" value={name} onChange={(e) => {
                                setName(e.target.value);
                            }} />
                        </Box>
                        <Box mb={1}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Title</label>
                            <TextField inputProps={{ maxLength: "50" }} style={{
                                border: `1px solid ${pcolor}`, borderRadius: 5,
                                width: "100%"
                            }} variant="outlined" label="" value={title} onChange={(e) => {
                                setTitle(e.target.value);
                            }} />
                        </Box>
                        <Box mb={1}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Organisation</label>
                            <TextField inputProps={{ maxLength: "190" }} style={{
                                border: `1px solid ${pcolor}`, borderRadius: 5,
                                width: "100%"
                            }} variant="outlined" label="" value={organizationName} onChange={(e) => {
                                setOrganizationName(e.target.value);
                            }} />
                        </Box>
                        <Box py={2} textAlign="center">
                            <button type="submit" disabled={loading}
                                style={{
                                    border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.5rem",
                                    height: "50px", width: "444px", borderRadius: 2
                                }}>{loading ? <CircularProgress size={20} /> : null} Register</button>
                        </Box>
                        {error !== "" ? <Box mt={1} mb={2} style={{ color: rcolor, fontSize: "1.1rem", textAlign: "center" }}>{error}</Box> : null}
                        {success !== "" ? <Box mt={1} mb={2} style={{ color: "green", fontSize: "1.1rem", textAlign: "center" }}>{success}</Box> : null}
                    </form>
                    <Box sx={{ textAlign: "center", fontSize: "1.20rem", margin: "15px 0px" }}>
                        <Button type="button" style={{
                            padding: "5px",
                            textTransform: 'none',
                            color: pcolor,
                            fontSize: "1.2rem",
                            '&:hover': {
                                textDecoration: 'underline',
                                backgroundColor: 'transparent',
                            },
                        }}
                            onClick={() => { setRedirect(`/referral/Login/${orgCode}`) }}><Typography style={{ marginRight: "10px", color: blackcolor, fontSize: "1.2rem" }}>Already a Registered</Typography> Login</Button>

                    </Box>
                    <Box sx={{ textAlign: "center", fontSize: "1.20rem", margin: "15px 0px" }}>
                        Problems registering? <Link href="mailto:contact@enrichmycare.com" target="_blank" rel="noreferrer">Contact Us</Link>
                    </Box>
                </Box>}
            <Box sx={{...footerContainer, position:"static"}}>
                <Footer />
            </Box>
        </Box>;
}